export interface ApiError {
  message: string;
  code?: string;
  status?: number;
  details?: Record<string, unknown>;
}

export interface ApiResponse<T> {
  data: T;
  status: number;
  headers?: Headers;
}

export type ApiResult<T> =
  | { success: true; data: T }
  | { success: false; error: ApiError };

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as ApiError).message === 'string'
  );
}

export function createApiError(
  message: string,
  status?: number,
  code?: string,
  details?: Record<string, unknown>
): ApiError {
  return { message, status, code, details };
}

export class ApiException extends Error {
  public readonly status?: number;
  public readonly code?: string;
  public readonly details?: Record<string, unknown>;

  constructor(error: ApiError) {
    super(error.message);
    this.name = 'ApiException';
    this.status = error.status;
    this.code = error.code;
    this.details = error.details;
  }
}

export function isExpiredSessionError(error: unknown): boolean {
  if (error instanceof ApiException) {
    return error.status === 401 || error.code === 'invalid-access-token';
  }

  if (isApiError(error)) {
    return error.status === 401 || error.code === 'invalid-access-token';
  }

  return false;
}
